const serverAddress = {
    'producao': 'https://portalcompras.hebraica.org.br/',
    'homologacao': 'https://portalcompras_homolog.hebraica.org.br/',
    'desenvolvimento': 'http://192.168.68.68:8000/'
}

const serverUrl = serverAddress.producao;

const apisettigs = {
    'serverUrl': serverUrl,
    'endpoints': {
        'checkauth': serverUrl + 'mobile/api/checkauth',
        'getauth': serverUrl + 'mobile/api/getauth',
        'topbar': serverUrl + 'mobile/api/topbar',
        'home': serverUrl + 'mobile/api/home',
        'homeShowPerms': serverUrl +  'mobile/api/homeshowperms',
        'requests': serverUrl + 'mobile/api/request',
        'approveRequest': serverUrl + 'mobile/api/request/approve',
        'rejectRequest': serverUrl + 'mobile/api/request/reject',
        'approveAllRequest': serverUrl + 'mobile/api/request/approveall',
        'messages': serverUrl + 'mobile/api/messages',
        'messages2': serverUrl + 'mobile/api/messages2',
        'markMessage': serverUrl + 'mobile/api/messages/mark',
        'addMessage': serverUrl + 'mobile/api/messages/add',
        'messageRecipients': serverUrl + 'mobile/api/messages/getrecipients',
        'addNewMessage': serverUrl + 'mobile/api/messages/addnew',
        'listitens': serverUrl + 'mobile/api/listitems',
        'orders': serverUrl + 'mobile/api/order',
        'approveOrder': serverUrl + 'mobile/api/order/approve',
        'rejectOrder': serverUrl + 'mobile/api/order/reject',
        'approveAllOrders': serverUrl + 'mobile/api/order/approveall',
        'listquotations': serverUrl + 'mobile/api/listquots', 
        'listsolics': serverUrl + 'mobile/api/listsolics',
        'centralMessages': serverUrl + 'mobile/api/centralmessages',
        'ctrlMsgsShowMessage': serverUrl + 'mobile/api/centralmessages/showmessage',
        'ctrlMsgsMarkMsg': serverUrl + 'mobile/api/centralmessages/markmsg',
        'ctrlMsgsAddResp': serverUrl + 'mobile/api/centralmessages/addresponse',
    },
};

const ServerPaths = {
    'userPhoto': serverUrl + '/userprofile/photos/',
    //dev
    //'userPhoto': 'https://portalcompras_homolog.hebraica.org.br/userprofile/photos/',
}

export {apisettigs, ServerPaths, serverUrl};